import React from 'react';
import {
	ENTREGA_AGENDADA,
	SAIU_PARA_ENTREGA,
	PEDIDO_ENTREGUE,
	PEDIDO_NAO_ENTREGUE,
} from '../../constants/entregaStatus';

function num(porStatus, key){
	if(!porStatus || porStatus[key] === undefined || porStatus[key] === null) return '—';
	return porStatus[key];
}

export default function EntregasDashboardCards({ resumo, onCardClick, statusFiltro, semLoteFiltro }) {
	const total = resumo && resumo.total !== undefined && resumo.total !== null ? resumo.total : '—';
	const semLote = resumo && resumo.semLote !== undefined && resumo.semLote !== null ? resumo.semLote : '—';
	const porStatus = resumo ? resumo.porStatus : null;

	const activeTotal = !semLoteFiltro && !statusFiltro;
	const activeSemLote = semLoteFiltro === true;
	const activeStatus = (s) => !semLoteFiltro && statusFiltro === s;

	const cardCls = (extra, active) =>
		`entregasDashboard-card ${extra}${active ? ' is-active' : ''}`;

	return (
		<div className="entregasDashboard">
			<p className="entregasDashboard-hint">
				Números conforme bairro, período, entregador e busca; o filtro de situação da lista não altera este resumo. Clique em um card para filtrar a tabela.
			</p>
			<div className="entregasDashboard-grid">
				<button
					type="button"
					className={cardCls('entregasDashboard-card--total', activeTotal)}
					onClick={() => onCardClick('total')}
				>
					<span className="entregasDashboard-label">Total</span>
					<strong className="entregasDashboard-value">{total}</strong>
				</button>
				<button
					type="button"
					className={cardCls('entregasDashboard-card--semLote', activeSemLote)}
					onClick={() => onCardClick('semLote')}
				>
					<span className="entregasDashboard-label">Sem lote (agendada / reentrega)</span>
					<strong className="entregasDashboard-value">{semLote}</strong>
				</button>
				<button
					type="button"
					className={cardCls('entregasDashboard-card--agendada', activeStatus(ENTREGA_AGENDADA))}
					onClick={() => onCardClick(ENTREGA_AGENDADA)}
				>
					<span className="entregasDashboard-label">{ENTREGA_AGENDADA}</span>
					<strong className="entregasDashboard-value">{num(porStatus, ENTREGA_AGENDADA)}</strong>
				</button>
				<button
					type="button"
					className={cardCls('entregasDashboard-card--saiu', activeStatus(SAIU_PARA_ENTREGA))}
					onClick={() => onCardClick(SAIU_PARA_ENTREGA)}
				>
					<span className="entregasDashboard-label">{SAIU_PARA_ENTREGA}</span>
					<strong className="entregasDashboard-value">{num(porStatus, SAIU_PARA_ENTREGA)}</strong>
				</button>
				<button
					type="button"
					className={cardCls('entregasDashboard-card--entregue', activeStatus(PEDIDO_ENTREGUE))}
					onClick={() => onCardClick(PEDIDO_ENTREGUE)}
					title="Lista ordenada pela entrega concluída mais recente (última atualização)"
				>
					<span className="entregasDashboard-label">{PEDIDO_ENTREGUE}</span>
					<strong className="entregasDashboard-value">{num(porStatus, PEDIDO_ENTREGUE)}</strong>
				</button>
				<button
					type="button"
					className={cardCls('entregasDashboard-card--naoEntregue', activeStatus(PEDIDO_NAO_ENTREGUE))}
					onClick={() => onCardClick(PEDIDO_NAO_ENTREGUE)}
				>
					<span className="entregasDashboard-label">{PEDIDO_NAO_ENTREGUE}</span>
					<strong className="entregasDashboard-value">{num(porStatus, PEDIDO_NAO_ENTREGUE)}</strong>
				</button>
			</div>
		</div>
	);
}
